import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/weddingHall'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import { getMerchantInfo } from '@util'

// 配套设施
export const facilitiesConfig = [
  { name: 'huazhuang', label: '化妆间' },
  { name: 'yingbin', label: '迎宾区' },
  { name: 'xiuxi', label: '宾客休息区' },
  { name: 'led', label: 'LED屏' },
  { name: 'light', label: '灯光' },
  { name: 'sound', label: '音响' }
]
// 其他费用 radio选项
export const otherFeeRadioConfig = [
  { name: 'place_fee', label: '场地费' },
  { name: 'jinchang', label: '婚庆入场费' },
  { name: 'service_fee', label: '服务费' },
  { name: 'open_fee', label: '开瓶费' },
  { name: 'led_fee', label: 'LED屏使用费' },
  { name: 'sound_fee', label: '音响使用费' },
  { name: 'light_fee', label: '灯光使用费' }
]
// eslint-disable-next-line
const INITIAL_DATA = {
  name: 'hello',
  max_table_num: 1,
  best_table_num: 1,
  area: 1,
  height: 1,
  pillar: 1,
  shape: '长方形',
  other: 'sdfsfsdfs',
  cover: '//qnm.hunliji.com/o_1dgf0c8eb50n1bpn1dv4tte1m6h9.png',
  items: [
    {
      id: 1,
      url: '//qnm.hunliji.com/o_1dgf0c8eb50n1bpn1dv4tte1m6h9.png',
      width: 400,
      height: 400
    },
    {
      id: 2,
      url: '//qnm.hunliji.com/o_1dgf0c8eb50n1bpn1dv4tte1m6h9.png',
      width: 400,
      height: 400
    },
    {
      id: 3,
      url: '//qnm.hunliji.com/o_1dgf0c8eb50n1bpn1dv4tte1m6h9.png',
      width: 400,
      height: 400
    }
  ]
}

const NEED_REDEFINE_FIEDS = ['yingbin', 'huazhuang', 'xiuxi', 'jinchang'] // 初始值需修改的字段

class Store {
  constructor(id, isFromShuijing, isHunlitang) {
    this.id = id
    this.isFromShuijing = !!isFromShuijing // 是否来自水镜同步场地
    this.isHunlitang = isHunlitang
    this.type = id ? 'edit' : 'add' // id 存在则为编辑
    this.loading = !!id
  }

  @observable detail = {}
  @observable hallMarks = []
  @observable topWeddingTags = []
  @observable selectedTopWeddingTag = []
  @observable loading = true
  @observable submitLoading = false
  @observable isHunlitang = false
  @action
  getDetail = async id => {
    const { success, data } = await Api.getHallInfo({ id })
    runInAction(() => {
      if (success) {
        let _data = { ...data }
        /**
         * 老数据初始值修改
         */
        NEED_REDEFINE_FIEDS.forEach(item => {
          if (_data[item] === -1) {
            _data[item] = undefined
          }
        })
        // 配套设施初始化（后端返回的接口不规范，只能前端处理下了）
        const facilitiesData = {}
        facilitiesConfig.forEach(item => {
          facilitiesData[item.name] =
            data[item.name] != null ? { checked: data[item.name] } : null
        })
        _data.hall_device_items.forEach(item => {
          const img = item.url
            ? {
                url: item.url,
                width: item.width,
                height: item.height,
                type: 'image'
              }
            : null
          if (facilitiesData[item.type]?.imgs?.length) {
            img && facilitiesData[item.type].imgs.push(img)
          } else {
            facilitiesData[item.type] = {
              checked: 1,
              desc: item.desc,
              imgs: [img].filter(Boolean)
            }
          }
        })

        this.detail = Object.assign({}, _data, {
          nature_items: _data.nature_items?.map((item, index) => ({
            ...item,
            type: 'image'
          })),
          decorative_items: _data.decorative_items?.map((item, index) => ({
            ...item,
            type: 'image'
          })),
          case_items: !this.isHunlitang
            ? _data.case_items?.length
              ? _data.case_items?.map((item, index) => {
                  return item.map(item_ => ({
                    ...item_,
                    type: 'image'
                  }))
                })
              : [[]]
            : _data.case_items?.[0]?.map((item, index) => {
                return {
                  ...item,
                  type: 'image'
                }
              }),
          ...facilitiesData
        })
        this.selectedTopWeddingTag = _data.top_label || []
        this.loading = false
      }
    })
  }

  getHallMarks = async () => {
    const { success, data } = await Api.getHallMarksApi()
    runInAction(() => {
      if (success && data && data.length) {
        this.hallMarks = data.map(({ mark_id, name }) => ({
          label: name,
          value: mark_id
        }))
      }
    })
  }

  editHall = async params => {
    const {
      hall_type,
      area_1,
      area_2,
      pillar,
      cover_urls_1,
      cover_urls_2,
      mark_ids,
      shape_1,
      shape_2,
      nature_items_1,
      nature_items_2,
      decorative_items,
      case_items,
      ...rest
    } = params
    const cover_urls = hall_type === 1 ? cover_urls_1 : cover_urls_2
    const {
      cover_url,
      vertical_cover_url,
      cover_width,
      cover_height,
      vertical_width,
      vertical_height
    } =
      cover_urls || {}
    const items = hall_type === 1 ? nature_items_1 : nature_items_2
    const nature_items = (items || []).map(item => {
      const { width, height } = item.response || item
      return {
        width,
        height,
        url: item.url
      }
    })
    let case_items_transformed = (case_items || [[]]).map(item => {
      return Array.isArray(item)
        ? item.map(item_ => {
            return {
              url: item_.url,
              width: item_.width,
              height: item_.height
            }
          })
        : {
            url: item.url,
            width: item.width,
            height: item.height
          }
    })
    this.isHunlitang && (case_items_transformed = [case_items_transformed])
    const decorative_items_1 = (decorative_items || []).map(item => {
      const { width, height } = item.response || item
      return {
        width,
        height,
        url: item.url
      }
    })
    // 配套设施
    const hall_device_items = []
    const facilities = {}
    facilitiesConfig.forEach(item => {
      facilities[item.name] = params[item.name].checked
      if (params[item.name].checked) {
        const type = item.name
        const desc = params[item.name].desc
        if (params[item.name].imgs?.length > 0) {
          for (let i = 0; i < params[item.name].imgs.length; i++) {
            const img = params[item.name].imgs[i]
            hall_device_items.push({
              type,
              desc,
              width: img.width,
              height: img.height,
              url: img.url
            })
          }
        } else if (desc) {
          hall_device_items.push({ type, desc })
        }
      }
    })
    let body = {
      ...rest,
      hall_type,
      area: hall_type === 1 ? area_1 : area_2,
      shape: hall_type === 1 ? shape_1 : shape_2,
      pillar: pillar || '0',
      id: this.id || null,
      cover_url,
      vertical_cover_url,
      cover_width,
      cover_height,
      vertical_width,
      vertical_height,
      cover_urls: '',
      platform: this.isFromShuijing ? 3 : 1, // platform： 1为平台场地，3为水镜同步过来的场地
      mark_ids: mark_ids ? mark_ids.toString() : '',
      nature_items,
      case_items: case_items_transformed,
      decorative_items: decorative_items_1,
      hall_device_items,
      ...facilities
    }
    if (!!+getMerchantInfo().top_wedding) {
      body['top_label'] = this.selectedTopWeddingTag
    }
    this.submitLoading = true
    const { success } = await Api.editHall(body)
    runInAction(() => {
      this.submitLoading = false
    })
    if (success) {
      message.success('操作成功')
      hashHistory.push('/localMerchant/siteManage?key=2')
    }
  }

  @action
  getTopWeddingTag = async () => {
    let { data, success } = await Api.getTopWeddingTag()
    runInAction(() => {
      if (success) {
        this.topWeddingTags = data
      }
    })
  }

  @action
  changeTopWeddingTags = label_id => () => {
    this.selectedTopWeddingTag = this.selectedTopWeddingTag.some(
      el => el == label_id
    )
      ? []
      : [label_id]
  }
}

export default Store
